/**
 * TaskDependencyService
 * Service for TaskDependency entity operations
 * Route: api/task-dependencies
 * Controller: TaskDependencyController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * TaskDependencyService
 * Handles task dependency CRUD operations
 * Maps to /api/task-dependencies endpoint
 */
export class TaskDependencyService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? TaskDependencyService.DEFAULT_SERVICE_PATH,
            basePath: TaskDependencyService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
TaskDependencyService.DEFAULT_SERVICE_PATH = 'projects';
TaskDependencyService.BASE_PATH = 'api/task-dependencies';
//# sourceMappingURL=TaskDependencyService.js.map